import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_4 = { class: "card-buttons d-sm-flex align-items-center" }
const _hoisted_5 = { class: "d-sm-flex align-items-center" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}, " # ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}, " code ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " libelle ", -1)
const _hoisted_12 = {
  key: 0,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " stock ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}, " Actions ", -1)
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-paragraph"
}
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "badge text-white bg-primary fs-15 dropdown-toggle",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, [
      /*#__PURE__*/_createTextVNode(" Actions "),
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" })
  ])
], -1)
const _hoisted_27 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "search-box position-relative",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
          onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
          class: "form-control shadow-none text-black rounded-0 border-0",
          placeholder: "Rechercher un produit"
        }, null, 544), [
          [_vModelText, _ctx.searchTerm]
        ]),
        _hoisted_3
      ], 32),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getAll('produits'))),
          class: _normalizeClass(["card-btn mt-10 mt-sm-0 d-inline-block fw-medium text-decoration-none transition ps-10 pe-10 pt-5 pb-5", {'active': _ctx.stockName === 'produits'}])
        }, " Produit ", 2),
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getAll('produitConditionnements'))),
          class: _normalizeClass(["card-btn mt-10 mt-sm-0 d-inline-block fw-medium text-decoration-none transition ps-10 pe-10 pt-5 pb-5 ms-5", {'active': _ctx.stockName === 'produitConditionnements'}])
        }, " Produit Conditionnement ", 2),
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getAll('produitCondMags'))),
          class: _normalizeClass(["card-btn mt-10 mt-sm-0 d-inline-block fw-medium text-decoration-none transition ps-10 pe-10 pt-5 pb-5 ms-5", {'active': _ctx.stockName === 'produitCondMags'}])
        }, " Produit Magasin ", 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
          href: "javascript:;",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getFiche()))
        }, " Fiche de stock ")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              (_ctx.stockName=='produitConditionnements')
                ? (_openBlock(), _createElementBlock("th", _hoisted_12, " Qte Conditionnement "))
                : _createCommentVNode("", true),
              _hoisted_13,
              _hoisted_14
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (pro, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_15, _toDisplayString(pro.id), 1),
                _createElementVNode("td", _hoisted_16, [
                  (pro.code)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(pro.code), 1))
                    : _createCommentVNode("", true),
                  (pro?.produit)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(pro.produit.code), 1))
                    : _createCommentVNode("", true),
                  (pro?.produitConditionnement?.produit)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(pro.produitConditionnement.produit.code), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_20, [
                  (pro.libelle)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(pro.libelle), 1))
                    : _createCommentVNode("", true),
                  (pro?.nomComplet)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(pro.nomComplet), 1))
                    : _createCommentVNode("", true),
                  (pro?.produitConditionnement)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(pro.produitConditionnement.nomComplet), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.stockName=='produitConditionnements')
                  ? (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(pro.qteCond), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_25, _toDisplayString(pro.qteStock), 1),
                _hoisted_26
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}